import { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";

import Header from "../components/Header";
import Footer from "../components/Footer";

function Messages() {
  const { userId } = useParams();

  const [messages, setMessages] = useState([]);
  const [message, setMessage] = useState("");
  const [loading, setLoading] = useState(true);
  const [sending, setSending] = useState(false);

  const token = localStorage.getItem("token");

  // =========================
  // GET CURRENT USER ID
  // =========================

  let currentUserId = null;

  if (token) {
    try {
      const payload = JSON.parse(
        atob(token.split(".")[1])
      );

      currentUserId = payload.id;
    } catch (error) {
      console.error("Token error:", error);
    }
  }

  // =========================
  // GET MESSAGES
  // =========================

  useEffect(() => {
    const getMessages = async () => {
      if (!token) {
        setLoading(false);
        return;
      }

      try {
        const response = await fetch(
          `/api/messages/${userId}`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );

        const data = await response.json();

        if (!response.ok) {
          throw new Error(
            data.message ||
              "Չհաջողվեց ստանալ հաղորդագրությունները"
          );
        }

        setMessages(data);
      } catch (error) {
        console.error(
          "GET MESSAGES ERROR:",
          error
        );
      } finally {
        setLoading(false);
      }
    };

    getMessages();
  }, [userId, token]);

  // =========================
  // SEND MESSAGE
  // =========================

  const handleSendMessage = async () => {
    if (!token) {
      alert(
        "Հաղորդագրություն ուղարկելու համար մուտք գործեք։"
      );
      return;
    }

    if (!message.trim()) {
      return;
    }

    try {
      setSending(true);

      const response = await fetch(
        "/api/messages",
        {
          method: "POST",

          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },

          body: JSON.stringify({
            receiver: userId,
            text: message.trim(),
          }),
        }
      );

      const data = await response.json();

      if (!response.ok) {
        throw new Error(
          data.message ||
            "Չհաջողվեց ուղարկել հաղորդագրությունը"
        );
      }

      setMessages((prev) => [
        ...prev,
        data,
      ]);

      setMessage("");

    } catch (error) {
      console.error(
        "SEND MESSAGE ERROR:",
        error
      );

      alert(error.message);

    } finally {
      setSending(false);
    }
  };

  // =========================
  // NOT LOGGED IN
  // =========================

  if (!token) {
    return (
      <>
        <Header />

        <main className="container messages-page">

          <h1>Մուտք գործեք</h1>

          <p>
            Հաղորդագրություններ ուղարկելու և
            ստանալու համար անհրաժեշտ է մուտք գործել։
          </p>

          <Link to="/login">
            Մուտք գործել
          </Link>

        </main>

        <Footer />
      </>
    );
  }

  // =========================
  // PAGE
  // =========================

  return (
    <>
      <Header />

      <main className="messages-page">

        <div className="container">

          <div className="messages-header">

            <Link to="/products">
              ← Հայտարարություններ
            </Link>

            <h1>
              💬 Հաղորդագրություններ
            </h1>

          </div>


          <div className="messages-container">

            {/* MESSAGES */}

            <div className="messages-list">

              {loading ? (

                <div className="messages-loading">
                  Հաղորդագրությունները բեռնվում են...
                </div>

              ) : messages.length === 0 ? (

                <div className="no-messages">

                  <h2>
                    Դեռ հաղորդագրություններ չկան
                  </h2>

                  <p>
                    Գրեք վաճառողին և սկսեք զրույցը։
                  </p>

                </div>

              ) : (

                messages.map((item) => {

                  const isMine =
                    String(item.sender?._id) ===
                    String(currentUserId);

                  return (
                    <div
                      key={item._id}
                      className={
                        isMine
                          ? "message message-mine"
                          : "message message-other"
                      }
                    >

                      <div className="message-text">
                        {item.text}
                      </div>

                      <div className="message-date">
                        {new Date(
                          item.createdAt
                        ).toLocaleString(
                          "hy-AM"
                        )}
                      </div>

                    </div>
                  );

                })

              )}

            </div>


            {/* INPUT */}

            <div className="message-input-box">

              <textarea
                value={message}
                onChange={(e) =>
                  setMessage(e.target.value)
                }
                placeholder="Գրեք հաղորդագրություն..."
                rows="3"
                disabled={sending}
              />

              <button
                onClick={handleSendMessage}
                disabled={
                  sending ||
                  !message.trim()
                }
              >
                {sending
                  ? "Ուղարկվում է..."
                  : "📨 Ուղարկել"}
              </button>

            </div>

          </div>

        </div>

      </main>

      <Footer />
    </>
  );
}

export default Messages;